import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import {
    Box,
    TextField,
    FormControl,
    Grid,
    Button,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    Typography
} from "@mui/material";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import { UpdateOTAction, AddOTAction } from "../../../../../store/Finance/PayRollTemplate/Action";
import { GetCustomEarningAction } from "../../../../../store/Finance/Component/Action";

const OverTime = ({ editedRecord, setOpenPopup }) => {
    const dispatch = useDispatch();
    const initialValue = {
        overtime_type: "",
        overtime_policy: "Daily",
        daily_min_eligible_hours: 0,
        weekly_min_eligible_hours: "",
        flat_amount: "",
        variable_earning_components: [],
        variable_overtime_rate: "",
        alias_name: "",
        overtime_calculation_basis: ""
    };
    const [overtime, setOverTime] = useState(initialValue);
    const [errors, setErrors] = useState({});
    const [earningData, setEarningData] = useState({
        load: true,
        values: [],
    });
    const { custom_earning_data } = useSelector(
        (state) => state?.FinanceReducer.ComponentReducer
    );
    useEffect(() => {
        if (editedRecord != null) {
            setOverTime({
                ...editedRecord,
                overtime_calculation_basis: editedRecord?.on_custom ? "Custom Earnings" : editedRecord?.on_grosspay ? "Gross Salary" : editedRecord?.on_netpay ? "Net Salary" : "",
            });
        }
        dispatch(GetCustomEarningAction());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editedRecord]);
    const handleEarnings = () => {
        custom_earning_data &&
            setEarningData({ load: false, values: custom_earning_data?.[0]?.earnings_json });
    };
    const validate = (fieldValues = overtime) => {
        let temp = { ...errors };

        if ("overtime_type" in fieldValues)
            temp.overtime_type = fieldValues.overtime_type ? "" : "Overtime type is required.";
        
        if ("alias_name" in fieldValues && !editedRecord)
            temp.alias_name = fieldValues.alias_name ? "" : "Overtime code is required.";

        if ("flat_amount" in fieldValues && overtime.overtime_type === "Flat")
            temp.flat_amount = fieldValues.flat_amount ? "" : "Flat amount is required.";

        // if ("overtime_policy" in fieldValues && (overtime?.overtime_type === "Flat" || overtime?.overtime_type === "Variable"))
        //     temp.overtime_policy = fieldValues.overtime_policy ? "" : "OT Policy is required.";

        if ("variable_overtime_rate" in fieldValues && overtime.overtime_type === "Variable")
            temp.variable_overtime_rate = fieldValues.variable_overtime_rate
                ? ""
                : "Overtime rate is required.";
        if ("variable_earning_components" in fieldValues && overtime?.overtime_type === "Variable" && overtime?.overtime_calculation_basis === "Custom Earnings")
            temp.variable_earning_components =
                fieldValues.variable_earning_components?.length === 0
                    ? "Earning is required"
                    : fieldValues.variable_earning_components === null
                        ? "Earning is required"
                        : "";
        if ("daily_min_eligible_hours" in fieldValues && overtime?.overtime_type === "Variable") {
            const value = fieldValues.daily_min_eligible_hours;
            const isValid =
            value !== "" &&
            value !== null &&
            !isNaN(value) &&
            Number(value) >= 0;
            temp.daily_min_eligible_hours = isValid ? "" : "Daily Min Working Hrs must be 0 or more.";
        }
        if ("overtime_calculation_basis" in fieldValues && overtime?.overtime_type === "Variable") {
            temp.overtime_calculation_basis = fieldValues.overtime_calculation_basis ? "" : "Calculation basis is required.";
        }

        setErrors({ ...temp });

        return Object.values(temp).every((x) => x === "");
    };
    const handleInput = (event, value) => {

        if (["variable_earning_components"].includes(event)) {
            if (value) {
                setOverTime({ ...overtime, [event]: value });
            } else {
                setOverTime({ ...overtime, [event]: "" });
            }
            Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
                validate({ ...overtime, [event]: value ? value : "" });
        }
        else if (event.target.name === "overtime_type") {
            setOverTime({
                ...initialValue,
                alias_name: overtime?.alias_name,
                [event.target.name]: event.target.value,
            });
            setErrors({})
        }
        else if (event.target.name === "overtime_calculation_basis") {
            setOverTime({
                ...overtime,
                [event.target.name]: event.target.value,
                variable_earning_components: []
            });
        }
        
        // else if (event.target.name === "overtime_policy") {
        //     setOverTime({
        //         ...overtime,
        //         [event.target.name]: event.target.value,
        //     });
        // }
        else {
            setOverTime({
                ...overtime,
                [event.target.name]: event.target.value,
            });
            Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
                validate({
                    ...overtime,
                    [event.target.name]: event.target.value,
                })
        }

    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (validate()) {
            const transformedVariableEarningComponents = JSON.stringify(
                overtime?.variable_earning_components?.map((item) => ({
                    name: item.name,
                    label: item.label,
                }))
            );
            let on_grosspay = false;
            let on_netpay = false;
            let on_custom = false;

            if (overtime.overtime_calculation_basis === "Gross Salary") on_grosspay = true;
            else if (overtime.overtime_calculation_basis === "Net Salary") on_netpay = true;
            else if (overtime.overtime_calculation_basis === "Custom Earnings") on_custom = true;

            const payload = {
                ...overtime,
                variable_earning_components: overtime?.variable_earning_components?.length >= 1 ? transformedVariableEarningComponents || null : null,
                on_grosspay,
                on_netpay,
                on_custom
            };

            if (editedRecord?.overtime_configuration_pk) {
                dispatch(UpdateOTAction({
                    ...payload,
                    overtime_configuration_id: editedRecord?.overtime_configuration_pk
                }));
            }
            else {
                dispatch(
                    AddOTAction(payload)
                );
            }
            setOpenPopup(false);
        }
    };

    return (
        <Box component="form" onSubmit={handleSubmit} noValidate>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <TextField
                        size="small"
                        required
                        disabled={editedRecord ? true : false}
                        value={overtime?.alias_name}
                        onChange={handleInput}
                        variant="outlined"
                        fullWidth
                        id="alias_name"
                        label="Overtime Code"
                        name="alias_name"
                        autoComplete="alias_name"
                        {...(errors.alias_name && {
                            error: true,
                            helperText: errors.alias_name,
                        })}
                    />
                </Grid>   
                <Grid item xs={12} md={6}>
                    <FormControl fullWidth error={!!errors?.overtime_type} size="small">
                        <InputLabel id="overtime-type-label">Overtime Type *</InputLabel>
                        <Select
                            labelId="overtime-type-label"
                            name="overtime_type"
                            value={overtime?.overtime_type}
                            label="Overtime Type"
                            onChange={handleInput}
                        >
                            <MenuItem value="Flat">Flat</MenuItem>
                            <MenuItem value="Variable">Variable</MenuItem>
                        </Select>
                        <FormHelperText>{errors?.overtime_type}</FormHelperText>
                    </FormControl>
                </Grid>
                {overtime?.overtime_type === "Flat" && (
                    <Grid item xs={12} md={6}>
                        <TextField
                            size="small"
                            required
                            type="number"
                            value={overtime?.flat_amount}
                            onChange={handleInput}
                            variant="outlined"
                            fullWidth
                            placeholder="200"
                            id="flat_amount"
                            label="Amount/hr"
                            name="flat_amount"
                            autoComplete="flat_amount"
                            {...(errors.flat_amount && {
                                error: true,
                                helperText: errors.flat_amount,
                            })}
                        />
                    </Grid>
                )}
                {overtime?.overtime_type === "Variable" && (
                    <>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth error={!!errors?.overtime_calculation_basis} size="small">
                                <InputLabel id="overtime-calculation-basis-label">Overtime Calculation Basis *</InputLabel>
                                <Select
                                    labelId="overtime-calculation-basis-label"
                                    name="overtime_calculation_basis"
                                    value={overtime?.overtime_calculation_basis}
                                    label="Overtime Calculation Basis"
                                    onChange={handleInput}
                                >
                                    <MenuItem value="Gross Salary">Gross Salary</MenuItem>
                                    <MenuItem value="Net Salary">Net Salary</MenuItem>
                                    <MenuItem value="Custom Earnings">Custom Earnings</MenuItem>
                                </Select>
                                <FormHelperText>{errors?.overtime_calculation_basis}</FormHelperText>
                            </FormControl>
                        </Grid>
                        {overtime?.overtime_calculation_basis === "Custom Earnings" && (
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <SelectableSearch
                                    isOptionEqualToValue={(option, value) =>
                                        option.label === value.label
                                    }
                                    multiple={true}
                                    limitTags={1}
                                    label="Select an Earnings"
                                    fullWidth
                                    value={overtime?.variable_earning_components}
                                    loading={() => handleEarnings()}
                                    fieldLabel="label"
                                    required={true}
                                    variantType="outlined"
                                    name="variable_earning_components"
                                    size="small"
                                    onChangeEvent={handleInput}
                                    data={earningData}
                                    {...(errors.variable_earning_components && {
                                        error: true,
                                        helperText: errors.variable_earning_components,
                                    })}
                                />
                            </FormControl>
                        </Grid>)}
                        <Grid item xs={12} md={6}>
                            <TextField
                                size="small"
                                required
                                type="number"
                                value={overtime?.daily_min_eligible_hours}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (val === "" || (Number(val) >= 0 && Number(val) <= 24)) {
                                        handleInput(e);
                                    }
                                }}
                                variant="outlined"
                                fullWidth
                                id="daily_min_eligible_hours"
                                label="Daily Min Eligible OT Hrs"
                                name="daily_min_eligible_hours"
                                autoComplete="daily_min_eligible_hours"
                                {...(errors.daily_min_eligible_hours && {
                                    error: true,
                                    helperText: errors.daily_min_eligible_hours,
                                })}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                size="small"
                                required
                                type="number"
                                value={overtime?.variable_overtime_rate}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (val === "" || (Number(val) > 0 && Number(val) <= 100)) {
                                        handleInput(e);
                                    }
                                }}
                                variant="outlined"
                                fullWidth
                                id="variable_overtime_rate"
                                label="Overtime Rate"
                                placeholder="2"
                                name="variable_overtime_rate"
                                autoComplete="variable_overtime_rate"
                                {...(errors.variable_overtime_rate && {
                                    error: true,
                                    helperText: errors.variable_overtime_rate,
                                })}
                            />
                        </Grid>
                    </>
                )}
            </Grid>
            <Box sx={{ width: "100%", textAlign: "left", border: "1px solid #ccc", borderRadius: 2, p: 2, backgroundColor: "#f9f9f9", mt: 2 }}>
                <Typography variant="subtitle2" sx={{ color: "#555", fontWeight: 500, }}>
                ℹ️ Flat: Fixed overtime amount per hour, regardless of employee salary or earnings structure.
                </Typography>
                <Typography variant="subtitle2" sx={{ color: "#555", fontWeight: 500, }}>
                ℹ️ Variable: Minimum overtime hours an employee must work beyond regular working hours before overtime becomes payable.
                </Typography>
                <Typography variant="subtitle2" sx={{ color: "#555", fontWeight: 500, }}>
                  ℹ️ Overtime Rate: Overtime multiplier applied to the employee's calculated hourly rate. eg: 1 = Regular Pay, 2 = Double Pay.
                </Typography>
            </Box>
            <Box mt={3} display="flex" justifyContent="flex-end">
                <Button
                    type="submit"
                    variant="contained"
                    size="medium"
                    className="mpl-primary-btn"
                >
                    {editedRecord ? "Update" : "Save"}
                </Button>
            </Box>
        </Box>
    );
};
export default OverTime;
